<template>
    <div
        :class="isIPhoneX || isIPhoneXSMax || isIPhoneXR ? 'tabBar fr ac jsa ipx_pb' : 'tabBar fr ac jsa'"
    >
        <router-link class="tab" to="/">
            <span></span>
            <!-- <p>电影</p> -->
        </router-link>
        <!-- <router-link class="tab" to="/showIndex">
            <span></span>
        </router-link>
        <router-link class="tab" to="/mallIndex">
            <span></span>
        </router-link> -->
        <router-link class="tab" to="/meIndex">
            <span></span>
            <!-- <p>我的</p> -->
        </router-link>
    </div>
</template>

<script>
export default {
    name: "tabBar",
    data() {
        return {
            isIPhoneX: this.$global.isIPhoneX,
            isIPhoneXSMax: this.$global.isIPhoneXSMax,
            isIPhoneXR: this.$global.isIPhoneXR
        };
    }
};
</script>
<style lang="scss">
.tabBar {
    width: 100%;
    height: 98px;
    position: fixed;
    bottom: 0;
    background-color: #fff;
    border-top: 1px solid #d8d8d8; /*no*/
    .tab {
        list-style: none;
        text-align: center;
        span {
            display: block;
            width: 45px;
            // height: 45px;
            height: 70px;
            // margin-top: 10px;
        }
        p {
            height: 40px;
            line-height: 40px;
            color: #999;
        }
        &:nth-child(1) {
            span {
                background: url("../../../static/imgs/tabBar/movie.png")
                    no-repeat;
                background-size: 100%;
            }
        }
        // &:nth-child(2) {
        //     span {
        //         background: url("../../../static/imgs/tabBar/show.png")
        //             no-repeat;
        //         background-size: 100%;
        //     }
        // }
        // &:nth-child(3) {
        //     span {
        //         background: url("../../../static/imgs/tabBar/life.png")
        //             no-repeat;
        //         background-size: 100%;
        //     }
        // }
        &:nth-child(2) {
            span {
                background: url("../../../static/imgs/tabBar/me.png") no-repeat;
                background-size: 100%;
            }
        }
        a {
            display: block;
            height: 40px;
            line-height: 40px;
        }
    }
    .router-link-exact-active {
        &:nth-child(1) {
            span {
                background: url("../../../static/imgs/tabBar/movie_active.png")
                    no-repeat;
                background-size: 100%;
            }
        }
        // &:nth-child(2) {
        //     span {
        //         background: url("../../../static/imgs/tabBar/show_active.png")
        //             no-repeat;
        //         background-size: 100%;
        //     }
        // }
        // &:nth-child(3) {
        //     span {
        //         background: url("../../../static/imgs/tabBar/life_active.png")
        //             no-repeat;
        //         background-size: 100%;
        //     }
        // }
        &:nth-child(2) {
            span {
                background: url("../../../static/imgs/tabBar/me_active.png")
                    no-repeat;
                background-size: 100%;
            }
        }
        p {
            color: #ec5f2a;
        }
    }
}
.ipx_pb {
    height: 138px;
    padding-bottom: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/tabBar.vue